import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-information-block',
    templateUrl: './information-block.component.html',
    styleUrls: ['./information-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InformationBlockComponent {
  @Input() text!: string;
  @Input() shortText?: string;

  @Input() mode: 'default' | 'compact' | 'bubble' | 'bubble-inline' = 'default';

  @Input() status: 'info' | 'warning' | 'error' = 'info';

  
  expanded = false;

  get hasToggle(): boolean {
    return !!this.shortText && this.shortText !== this.text;
  }

  get displayedText(): string {
    if (!this.hasToggle || this.expanded) {
      return this.text;
    }

    return this.shortText!;
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
